import { Outlet, NavLink, Link } from 'react-router-dom';
import {
  LayoutDashboard,
  AlertTriangle,
  Database,
  CheckSquare,
  FileText,
} from 'lucide-react';
import { useCompanyFilter } from '../contexts/CompanyFilterContext';

export function VeevaReconcileLayout() {
  const { companies, companiesLoading, selectedCompany, setSelectedCompany } =
    useCompanyFilter();

  const navItems = [
    { path: '/veevaReconcile', icon: LayoutDashboard, label: 'Dashboard', exact: true },
    { path: '/veevaReconcile/issues', icon: AlertTriangle, label: 'Issues' },
    { path: '/veevaReconcile/transactions', icon: Database, label: 'Transactions' },
    { path: '/veevaReconcile/approvals', icon: CheckSquare, label: 'Approvals' },
    { path: '/veevaReconcile/audit', icon: FileText, label: 'Audit Log' },
  ];

  return (
    <div>
      {/* Breadcrumb bar matching shell's .nav2 pattern */}
      <div className="container">
        <div className="group">
          <div className="nav2 span12">
            <div className="user">
              <em style={{ fontSize: '18px' }} className="fa fa-user"></em>{' '}
              Company name and number/division
            </div>
            <div className="bread-crumb">
              <Link to="/">
                <i style={{ fontSize: '18px' }} className="fa fa-home"></i> Home
              </Link>{' '}
              / Veeva Reconcile
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <h1>Veeva Reconcile</h1>

        {/* Company filter */}
        <div className="group" style={{ marginBottom: '15px' }}>
          <div className="span4">
            <div className="field">
              <select
                value={selectedCompany}
                onChange={(e) => setSelectedCompany(e.target.value)}
                disabled={companiesLoading}
              >
                <option value="">All Companies</option>
                {companies.map((name) => (
                  <option key={name} value={name}>{name}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Tab navigation */}
        <div style={{
          display: 'flex',
          gap: '2px',
          backgroundColor: 'rgba(255,255,255,0.06)',
          borderRadius: '8px 8px 0 0',
          padding: '4px 4px 0',
          borderBottom: '2px solid #0098DB',
          marginBottom: '20px',
        }}>
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.exact}
              style={({ isActive }) => ({
                display: 'flex',
                alignItems: 'center',
                gap: '7px',
                padding: '10px 20px',
                fontSize: '14px',
                fontWeight: isActive ? 700 : 500,
                letterSpacing: '0.3px',
                color: isActive ? '#fff' : 'rgba(255,255,255,0.75)',
                backgroundColor: isActive ? '#0098DB' : 'transparent',
                textDecoration: 'none',
                borderRadius: '6px 6px 0 0',
                transition: 'background-color 0.2s, color 0.2s',
                borderBottom: isActive ? '2px solid #0098DB' : '2px solid transparent',
                marginBottom: '-2px',
              })}
              onMouseEnter={(e) => {
                const el = e.currentTarget;
                if (!el.classList.contains('active')) {
                  el.style.backgroundColor = 'rgba(255,255,255,0.1)';
                  el.style.color = '#fff';
                }
              }}
              onMouseLeave={(e) => {
                const el = e.currentTarget;
                if (!el.classList.contains('active')) {
                  el.style.backgroundColor = 'transparent';
                  el.style.color = 'rgba(255,255,255,0.75)';
                }
              }}
            >
              <item.icon style={{ width: '16px', height: '16px' }} />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </div>

        {/* Page content */}
        <Outlet />

        <div className="clear"></div>
      </div>
    </div>
  );
}
